import { TestSuiteType } from "@app.raytd.com/common/types/test-suite-types";
import FieldDefaults from "@app.raytd.com/common/types/field-defaults";
import { translateFieldName } from "./translateFieldName";

export const getDefaultFieldSettings = (
    originalFieldName: string,
    testSuiteType: TestSuiteType
  ): FieldDefaults => {
  
    let fieldName = translateFieldName(originalFieldName);
  
    const baseFields = {
      asset: { active: true, required: true },
      location: { active: true, required: true },
      element: { active: true, required: true },
      element_name: { active: true, required: true },
      element_id: { active: true, required: true }
    };
  
    const testSuiteSpecificFields: Record<TestSuiteType, Record<string, FieldDefaults>> = {
      compliance: {
        test: { active: true, required: true },
        observations: { active: true, required: true },
        recommendations: { active: true, required: true },
        photographs: { active: true, required: true },
        rating: { active: true, required: true },
      },
      condition: {
        rating: { active: true, required: true },
        observations: { active: true, required: true },
        recommendations: { active: true, required: true },
        photographs: { active: true, required: true },
      },
      generic: {
        photographs: { active: true, required: true },
        observations: { active: true, required: true },
        recommendations: { active: true, required: true },
        rating: { active: false, required: false },
      },
      numerical: {
        rating: { active: true, required: true },
        observations: { active: true, required: false },
        recommendations: { active: true, required: false },
        photographs: { active: true, required: false },
      }
    };
  
    return (
      (baseFields as Record<string, FieldDefaults>)[fieldName] ||
      testSuiteSpecificFields[testSuiteType]?.[fieldName] ||
      { active: true, required: false }
    );
  };